export const KEYS = {
  ACCURAL: 'ACCURAL',
  CASH: 'CASH',
};

const convertToOption = (item) => ({
  label: `REPORT_TYPE.${item}`,
  value: item,
});

const LIST = Object.keys(KEYS);

export default LIST.map(convertToOption);

export type REPORT_TYPE_TYPES = typeof LIST[number] | undefined;
